import PercentageSlider from './PercentageSlider';

export default PercentageSlider
